/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GmapServiceDetails } from '../models/gmap-service-details';

@Injectable({
  providedIn: 'root',
})
export class GMapServiceService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getDailyConsumption
   */
  static readonly GetDailyConsumptionPath = '/api/v1/gmap/dailyConsumption';

  /**
   * Sync Daily Consumption.
   *
   * This API will copy consumption data from BigQuery
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDailyConsumption()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDailyConsumption$Response(params: {
    date?: string;
    costCalculation: boolean;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, GMapServiceService.GetDailyConsumptionPath, 'post');
    if (params) {
      rb.query('date', params.date, {});
      rb.query('costCalculation', params.costCalculation, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Sync Daily Consumption.
   *
   * This API will copy consumption data from BigQuery
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDailyConsumption$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDailyConsumption(params: {
    date?: string;
    costCalculation: boolean;
  }): Observable<string> {

    return this.getDailyConsumption$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation findSkuIdsWithServiceIds
   */
  static readonly FindSkuIdsWithServiceIdsPath = '/api/v1/getGmapSkus';

  /**
   * Get SKU Ids.
   *
   * This API is used to fetch SKU Ids of all GMap services based on service Ids.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findSkuIdsWithServiceIds()` instead.
   *
   * This method doesn't expect any request body.
   */
  findSkuIdsWithServiceIds$Response(params?: {
    serviceIds?: Array<string>;
  }): Observable<StrictHttpResponse<Array<GmapServiceDetails>>> {

    const rb = new RequestBuilder(this.rootUrl, GMapServiceService.FindSkuIdsWithServiceIdsPath, 'get');
    if (params) {
      rb.query('serviceIds', params.serviceIds, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<GmapServiceDetails>>;
      })
    );
  }

  /**
   * Get SKU Ids.
   *
   * This API is used to fetch SKU Ids of all GMap services based on service Ids.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findSkuIdsWithServiceIds$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findSkuIdsWithServiceIds(params?: {
    serviceIds?: Array<string>;
  }): Observable<Array<GmapServiceDetails>> {

    return this.findSkuIdsWithServiceIds$Response(params).pipe(
      map((r: StrictHttpResponse<Array<GmapServiceDetails>>) => r.body as Array<GmapServiceDetails>)
    );
  }

  /**
   * Path part for operation findAllGmapServices
   */
  static readonly FindAllGmapServicesPath = '/api/v1/getGmapServices';

  /**
   * Get All GMap Services.
   *
   * This API is used to fetch all the available GMap services.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAllGmapServices()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllGmapServices$Response(params?: {
  }): Observable<StrictHttpResponse<Array<GmapServiceDetails>>> {

    const rb = new RequestBuilder(this.rootUrl, GMapServiceService.FindAllGmapServicesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<GmapServiceDetails>>;
      })
    );
  }

  /**
   * Get All GMap Services.
   *
   * This API is used to fetch all the available GMap services.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findAllGmapServices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllGmapServices(params?: {
  }): Observable<Array<GmapServiceDetails>> {

    return this.findAllGmapServices$Response(params).pipe(
      map((r: StrictHttpResponse<Array<GmapServiceDetails>>) => r.body as Array<GmapServiceDetails>)
    );
  }

}
